import {
  getSecretValue as publicGetSecretValue,
  listSecretInfo as publicListSecretInfo,
  createSecret as publicCreateSecret,
  deleteSecret as publicDeleteSecret,
  updateSecret as publicUpdateSecret,
} from './velo-secrets-vault-v1-secret-secrets.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onSecretCreated as publicOnSecretCreated } from './velo-secrets-vault-v1-secret-secrets.public.js';
import { onSecretDeleted as publicOnSecretDeleted } from './velo-secrets-vault-v1-secret-secrets.public.js';
import { onSecretUpdated as publicOnSecretUpdated } from './velo-secrets-vault-v1-secret-secrets.public.js';

export const getSecretValue: MaybeContext<
  BuildRESTFunction<typeof publicGetSecretValue> & typeof publicGetSecretValue
> = /*#__PURE__*/ createRESTModule(publicGetSecretValue);
export const listSecretInfo: MaybeContext<
  BuildRESTFunction<typeof publicListSecretInfo> & typeof publicListSecretInfo
> = /*#__PURE__*/ createRESTModule(publicListSecretInfo);
export const createSecret: MaybeContext<
  BuildRESTFunction<typeof publicCreateSecret> & typeof publicCreateSecret
> = /*#__PURE__*/ createRESTModule(publicCreateSecret);
export const deleteSecret: MaybeContext<
  BuildRESTFunction<typeof publicDeleteSecret> & typeof publicDeleteSecret
> = /*#__PURE__*/ createRESTModule(publicDeleteSecret);
export const updateSecret: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSecret> & typeof publicUpdateSecret
> = /*#__PURE__*/ createRESTModule(publicUpdateSecret);
/**
 * Triggered when a secret is created.
 */
export const onSecretCreated: BuildEventDefinition<
  typeof publicOnSecretCreated
> &
  typeof publicOnSecretCreated = createEventModule(publicOnSecretCreated);
/**
 * Triggered when a secret is deleted.
 */
export const onSecretDeleted: BuildEventDefinition<
  typeof publicOnSecretDeleted
> &
  typeof publicOnSecretDeleted = createEventModule(publicOnSecretDeleted);
/**
 * Triggered when a secret is updated.
 */
export const onSecretUpdated: BuildEventDefinition<
  typeof publicOnSecretUpdated
> &
  typeof publicOnSecretUpdated = createEventModule(publicOnSecretUpdated);

export { WebhookIdentityType } from './velo-secrets-vault-v1-secret-secrets.universal.js';
export {
  Secret,
  GetSecretValueRequest,
  GetSecretValueResponse,
  ListSecretInfoRequest,
  ListSecretInfoResponse,
  CreateSecretRequest,
  CreateSecretResponse,
  DeleteSecretRequest,
  DeleteSecretResponse,
  UpdateSecretRequest,
  UpdateSecretResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  SecretCreatedEnvelope,
  SecretDeletedEnvelope,
  SecretUpdatedEnvelope,
} from './velo-secrets-vault-v1-secret-secrets.universal.js';
export { WebhookIdentityTypeWithLiterals } from './velo-secrets-vault-v1-secret-secrets.universal.js';
